import { ChartComponent, SeriesCollectionDirective, SeriesDirective, LineSeries, Inject, DateTime, Legend, Tooltip } from "@syncfusion/ej2-react-charts"
import {lineCustomSeries, LinePrimaryYAxis, LinePrimaryXAxis} from '../../data/dummy'
import { useStateContext } from "../../context/ContextProvider"

const LineChart = () => {
  const {currentMode} = useStateContext()
  return (
    <ChartComponent
      id='line-chart'
      height='420px'
      width='auto'
      primaryXAxis={LinePrimaryXAxis}
      primaryYAxis={LinePrimaryYAxis}
      chartArea={{border: {width: 0}}}
      tooltip={{enable: true}}
      background={currentMode==='Dark'? '#33373E': '#fff'}
    >
      <Inject services={[DateTime, Legend, Tooltip, LineSeries]}/>
      <SeriesCollectionDirective>
        {lineCustomSeries.map((item, index)=> <SeriesDirective key={index} {...item}/>)}
      </SeriesCollectionDirective>
    </ChartComponent>
  )
}

export default LineChart